
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/app/apps/web-commerce/sentry.client.config.ts")
            }
          });